module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-75.23879022.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-C-lvl2-75.png
// module id = 3391
// module chunks = 11